'use strict';

export const FETCH_USER_STATS = 'userStats/FETCH_USER_STATS';
export const FETCH_USER_STATS_COMPLETED = 'userStats/FETCH_USER_STATS_COMPLETED';
